<template>
  <v-card class="rsl-fixed-height">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('DOCUMENTS.SEARCH_TEXT')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="allFiles"
      :items-per-page="25"
      :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
      :search="search"
      class="elevation-1 mx-3 mb-3"
      item-key="ITEM_ID"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      loading-text="Loading... Please wait"
      :loading="loading"
    >
      <template slot="item.actions" slot-scope="row">
        <v-btn
          v-if="row.item.IS_LOCAL"
          small
          class="mr-2"
          color="success"
          @click="downloadFile(row.item)"
        >
          {{ $t('GENERAL.BTNS.DOWNLOAD') }}
        </v-btn>
        <v-btn
          v-if="!row.item.IS_LOCAL"
          small
          class="mr-2"
          color="success"
          @click="openFile(row.item)"
        >
          {{ $t('GENERAL.BTNS.OPEN') }}
        </v-btn>
        <v-btn
          small
          class="mr-2"
          color="error"
          @click="deleteFile(row.item)"
        >
          {{ $t('GENERAL.BTNS.DELETE') }}
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="deleteFileDialog"
      :retain-focus="false"
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ deleteFileTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ deleteFileText }}</div>
            <div class="pt-5">{{ deleteFileName }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="deleteFileDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmDeleteFile()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-card>
</template>

<script>
  import $ from 'jquery';
  import { mapGetters } from 'vuex';
  export default {
    name: 'documents',
    computed: {
      ...mapGetters(['allFiles', 'downloadFileName', 'downloadFileUrl'])
    },
    data: function() {
      return {
        currentRole: this.$store.state.currentRole,
        loading: false,
        deleteFileDialog: false,
        deleteFileTitle: '',
        deleteFileText: '',
        deleteFileName: '',
        deleteFileId: '',
        deleteFileGroupId: '',
        deleteLocalFile: false,
        theFileName: '',
        theCaseId: 0,
        theProcessName: '',
        theTaskName: '',
        search: '',
        sortBy: '',
        sortDesc: false,
        headers: [
          { text: this.$t('DOCUMENTS.FIELDS.CASE_ID'), align: 'start', sortable: true, value: 'ID' },
          { text: this.$t('DOCUMENTS.FIELDS.PROCESS_NAME'), value: 'PROCESS_NAME' },
          { text: this.$t('DOCUMENTS.FIELDS.TASK_NAME'), value: 'TASK_NAME' },
          { text: this.$t('DOCUMENTS.FIELDS.FILENAME'), sortable: true, value: 'FILE_NAME' },
          { text: this.$t('DOCUMENTS.FIELDS.SIZE'), value: 'FILE_SIZE', sortable: true },
          { text: this.$t('DOCUMENTS.FIELDS.CREATED_ON'), value: 'CREATED', sortable: false },
          { text: this.$t('DOCUMENTS.FIELDS.UPLOADED_BY'), value: 'UPLOADED_BY' },
          { text: this.$t('DOCUMENTS.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ]
      }
    },
    created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if (mutation.type === 'DELETED_FILE') {
          this.refreshFiles();
        }

      });
      this.refreshFiles();
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      refreshFiles() {
        this.loading = true;
        this.$store.dispatch('getAllFiles', this.currentRole).then( () => {
          this.loading = false;
          // Apply sort field and order
          let field = this.$store.state.ocumentsSortField;
          let sort = this.$store.state.documentsSortOrder;
          if(field == null) {
            this.sortBy = 'ID';
            this.sortDesc = true;
          }else if (sort == 'none') {
            this.sortBy = '';
            this.sortDesc = false;
          }else {
            this.sortBy = field;

            if(sort == 'descending') {
              this.sortDesc = true;
            }else {
              this.sortDesc = false;
            }
          }
          // Remove previous click events
          $('.text-start.sortable').off();
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            for(let i = 0; i < ref.headers.length; i++) {
              if(column == ref.headers[i].text) {
                ref.$store.commit('setDocumentsSortField', ref.headers[i].value);
                ref.$store.commit('setDocumentsSortOrder', order);
              }
            }
          });
        });
      },
      async downloadFile(item) {
        await this.$store.dispatch('downloadFile', item.ITEM_ID).then( () => {
          let e = document.createEvent('MouseEvents');
          let a = document.createElement('a');

          a.download = this.downloadFileName;
          a.href = this.downloadFileUrl;
          e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          a.dispatchEvent(e);
        });
      },
      openFile(item) {
        window.open(item.FILE_URL, '_blank');
      },
      deleteFile(item) {
        let type = '';
        if(item.IS_LOCAL) {
          type = 'local storage?';
        }else {
          type = 'OneDrive?';
        }

        this.deleteFileTitle = this.$t('DOCUMENTS.DELETE_DOC.TITLE');
        this.deleteFileText = this.$t('DOCUMENTS.DELETE_DOC.DESC_1') + ' ' + type;
        this.deleteFileName = this.$t('DOCUMENTS.DELETE_DOC.DESC_2') + ' ' + item.FILE_NAME;
        this.deleteFileId = item.ITEM_ID;
        this.deleteFileGroupId = item.MS_GROUP_ID;
        this.deleteLocalFile = item.IS_LOCAL;
        this.theFileName = item.FILE_NAME;
        this.theCaseId = item.ID;
        this.theProcessName = item.PROCESS_NAME;
        this.theTaskName = item.TASK_NAME;
        this.deleteFileDialog = true;
      },
      async confirmDeleteFile() {
        this.deleteFileDialog = false;
        if(!this.deleteLocalFile) {
          await this.$store.dispatch('getMSAuth').then( () => {
            let payload = {
              'fileId': this.deleteFileId,
              'groupId': this.deleteFileGroupId
            };
            this.$store.dispatch('deleteFile', payload).then( () => {
              this.updateLog('Document', 'Deleted', this.theCaseId, this.theProcessName, this.theTaskName, 'Document ' + this.theFileName + ' deleted from OneDrive.');
            });
          });
        }
        if(this.deleteLocalFile) {
          this.$store.dispatch('deleteLocalFile', this.deleteFileId).then( () => {
            this.updateLog('Document', 'Deleted', this.theCaseId, this.theProcessName, this.theTaskName, 'Document ' + this.theFileName + ' deleted from local storage.');
          });
        }
      },
      updateLog(cat, op, caseId, process, task, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        if(caseId == null) {
          caseId = 0;
        }

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': caseId,
          'processName': process,
          'taskName': task,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>
